import React, {Component} from 'react'
import {toJS} from 'mobx'
import {inject, observer} from 'mobx-react'
import {getPaginationConfig} from '../../../components/pagination'
import {Table, Button, Modal, Tooltip} from 'antd'
import {QuestionCircleFilled, EditOutlined, DeleteOutlined, LockOutlined, UnlockOutlined, SettingOutlined} from '@ant-design/icons'
import FormModal from './FormModal'
import {withTranslation} from 'react-i18next'
import GroupModal from './GroupModal'
import LimitModal from './LimitModal'

const storage = window.localStorage
const {confirm} = Modal

@inject('marketingManagementStore', 'accountStore')
@observer
class SearchResult extends Component {
  state = {
    addModalVisible: false,
    groupModalVisible: false,
    limitModalVisible: false,
    rowRecord: {},
    limitType: '',
    groupParams: {}
  }

  componentDidMount() {
  }

  handleEdit = (record) => {
    const {marketingManagementStore} = this.props
    marketingManagementStore.onGetJobAction(record.id).then(res => {
      this.setState({
        addModalVisible: true,
      })
    })
  }
  handleCancel = () => {
    this.setState({
      addModalVisible: false
    })
  }
  handleDel = (record) => {
    const {marketingManagementStore, t} = this.props
    confirm({
      title: t(`general.deleteData`),
      icon: <QuestionCircleFilled/>,
      content: t(`general.sureToDelete`),
      okText: t(`general.delete`),
      cancelText: t(`general.cancel`),
      onOk() {
        marketingManagementStore.onDeleteJobAction(record?.id)
      },
      onCancel() {
      },
    })
    return false
  }
  handlePageChange = (page, pageSize) => {
    const {marketingManagementStore} = this.props
    marketingManagementStore.onChangePageNumAction(page, pageSize)
  }
  getRowClassName = (record, index) => {
    let className = ''
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }
  handleChangeActive = (record) => {
    const {marketingManagementStore} = this.props
    marketingManagementStore.onChangeStatus({
      'status': record?.status === 0 ? 1 : record?.status === 1 ? 0 : null,
      'id': record?.id,
    })
  }

  handleEditGroup = (record) => {
    this.setState({groupModalVisible: true, rowRecord: record})
  }

  handleGroupCancel = () => {
    this.setState({
      groupModalVisible: false
    })
  }

  handleLimitModal = (type, record) => {
    const {marketingManagementStore} = this.props
    const params = {
      'marketGroupId': record?.id,
      'configType': type,
      'page': 1,
      'size': 10,
    }
    this.setState({
      groupParams: {
        'marketGroupId': record?.id,
        'configType': type,
      }
    })
    marketingManagementStore.groupLogList(params).then(() => {
      this.setState({limitModalVisible: true, limitType: type})
    })
  }

  handleLimitCancel = () => {
    this.setState({
      limitModalVisible: false
    })
  }

  render() {
    const themeStyle = JSON.parse(storage.getItem('themeStyle'))
    const {marketingManagementStore, accountStore, t} = this.props
    const {pageNo, pageSize, itemCount, jobList} = marketingManagementStore
    const pagination = getPaginationConfig(pageNo, pageSize, itemCount, this.handlePageChange)
    const {accountInfos} = accountStore
    const infos = JSON.parse(storage.getItem('accountInfos'))
    const isPowerUser = accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser || false
    return (
      <>
        <Table className="searchResult" dataSource={toJS(jobList)} pagination={pagination} rowKey="id" rowClassName={this.getRowClassName}
               scroll={{x: '130%'}} bordered>
          <Table.Column align="center" width={80} fixed="left" title={t(`marketingManagement.status`)} dataIndex="status" key="status"
                        render={text => <div style={{
                          display: 'inline-block',
                          height: 24,
                          width: 24,
                          lineHeight: '24px',
                          fontSize: 12,
                          borderRadius: 24,
                          color: 'white',
                          textAlign: 'center',
                          background: text === 0 ? themeStyle?.statusColor?.split(',')?.[0] || '#97cf7c' : themeStyle?.statusColor?.split(',')?.[1] || '#ef6e6e'
                        }} title={text === 0 ? '启用' : '停用'}>{text === 0 ? '启' : '停'}</div>}
          />
          <Table.Column width={150} title={t(`marketingManagement.groupName`)} dataIndex="groupName" key="groupName" ellipsis={true}/>
          <Table.Column width={150} title={t(`marketingManagement.marketingLimit`)} dataIndex="marketingSmsLimit" key="marketingSmsLimit"
                        ellipsis={true} render={
            (text, record) => {
              return <a style={{textDecoration: 'underline'}}
                          onClick={() => this.handleLimitModal('1', record)}>{text}</a>
            }
          }/>
          <Table.Column width={150} title={t(`marketingManagement.smsLimit`)} dataIndex="notificationSmsLimit" key="notificationSmsLimit"
                        ellipsis={true} render={
            (text, record) => {
              return <a style={{textDecoration: 'underline'}}
                          onClick={() => this.handleLimitModal('2', record)}>{text}</a>
            }
          }/>
          <Table.Column width={150} title={t(`marketingManagement.emailLimit`)} dataIndex="emailLimit" key="emailLimit" ellipsis={true} render={
            (text, record) => {
              return <a style={{textDecoration: 'underline'}}
                          onClick={() => this.handleLimitModal('3', record)}>{text}</a>
            }
          }/>
          <Table.Column width={150} title={t(`marketingManagement.shortLinkLimit`)} dataIndex="shortLinkLimit" key="shortLinkLimit" ellipsis={true}/>
          <Table.Column width={150} title={t(`marketingManagement.callLimit`)} dataIndex="callLimit" key="callLimit" ellipsis={true} render={
            (text, record) => {
              return <div style={{textDecoration: 'underline', color: 'rgba(7, 58, 120, 1)', cursor: 'pointer'}}
                          onClick={() => this.handleLimitModal('4', record)}>{text}</div>
            }
          }/>
          <Table.Column title={t(`marketingManagement.oneApprover`)} dataIndex="firstApprover" key="firstApprover" ellipsis={true}/>
          <Table.Column title={t(`marketingManagement.twoApprover`)} dataIndex="secondApprover" key="secondApprover" ellipsis={true}/>
          <Table.Column title={t(`marketingManagement.threeApprover`)} dataIndex="thirdApprover" key="thirdApprover" ellipsis={true}/>
          <Table.Column title={t(`marketingManagement.groupUser`)} dataIndex="groupMember" key="groupMember" ellipsis={true} render={text =>
            <Tooltip placement="topLeft" title={text.map(a => {return <div>{a}</div>})}>
              {[text.join(' , ')]}
            </Tooltip>
          }/>
          <Table.Column width={200} align="center" fixed="right" title={t(`general.action`)} key="Action" render={(text, record) => (
            isPowerUser ? <>
              <Button type="link" onClick={() => this.handleEdit(record)} icon={<EditOutlined/>} title={t(`general.edit`)}/>
              <Button type="link" onClick={() => this.handleChangeActive(record)}
                      icon={record.status === 0 ? <UnlockOutlined/> : <LockOutlined/>}
                      title={record.status === 0 ? t(`general.disable`) : t(`general.enable`)}/>
              <Button type="link" onClick={() => this.handleDel(record)} icon={<DeleteOutlined/>} title={t(`general.delete`)}/>
              <Button type="link" onClick={() => this.handleEditGroup(record)} icon={<SettingOutlined/>} title={t(`general.groupAdjustments`)}/>
            </> : null
          )}/>
        </Table>
        {this.state.addModalVisible ? <FormModal
          addModalVisible={this.state.addModalVisible}
          handleCancel={this.handleCancel}
          title="edit"
        /> : null}

        {/*分组调整弹窗*/}
        {this.state.groupModalVisible ? <GroupModal
          addModalVisible={this.state.groupModalVisible}
          handleCancel={this.handleGroupCancel}
          record={this.state.rowRecord}
        /> : null}

        {/*额度弹窗*/}
        {this.state.limitModalVisible ? <LimitModal
          addModalVisible={this.state.limitModalVisible}
          handleCancel={this.handleLimitCancel}
          limitType={this.state.limitType}
          groupParams={this.state.groupParams}
        /> : null}
      </>
    )
  }
}

export default withTranslation()(SearchResult)
